export const isGenericActionDisabled = ({ checkedMap, checkMode }: { checkedMap: Record<string, boolean>; checkMode: 'select-all' | 'single-select' }) => {
	if (checkMode === 'select-all') return false;
	return !Object.entries(checkedMap).some(([, value]) => value);
};
